export const reduxKey = '@@Gifting';

//# sourceMappingURL=constants.js.map